import {useGetProductInCart} from 'hooks/product/useGetProductInCart';
import {ProductBuyCartButton} from 'modules/product-card/components/ProductBuyCartButton';
import {ProductBuyCartCounter} from 'modules/product-card/components/ProductBuyCartCounter';
import {FC} from 'react';

export const ProductBuyCart: FC = () => {
    const productInCart = useGetProductInCart();

    if (productInCart) {
        return <ProductBuyCartCounter />;
    }

    return <ProductBuyCartButton />;
};
